import { Helmet } from "react-helmet";
import AboutHero from "../home/AboutHero";
import AboutServices from "../home/AboutServices";
import AboutLeadership from "../home/AboutLeadership";
import AboutMission from "../home/AboutMission";

export default function About() {
  return (
    <>
      <Helmet>
        <title>About GPS Finvest</title>
        <meta
          name="description"
          content="Learn more about GPS Finvest, our mission, values, and financial expertise in delivering top-notch services."
        />
      </Helmet>

      <AboutHero />
      <AboutServices />
      <AboutLeadership />
      <AboutMission />
    </>
  );
}
